import { combineReducers } from 'redux';

import transaction from './transaction';

const lean = combineReducers({
    transaction,
});

export default lean;
